import React, { useState } from "react";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Checkbox, Modal, Select, message } from "antd";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signin } from "../../redux/userSlice";
import Cookies from "js-cookie";
import jwt from "jsonwebtoken";
import jwt_decode from "jwt-decode";
import "./Login.css";
import EyeOnIcon from "../../assets/icons/eye-on.svg";
import EyeOffIcon from "../../assets/icons/eye-off.svg";

import EcouiItemsChecker from "../../components/EcouiItemsChecker";
import AuthLayout from "../AuthLayout/AuthLayout";
import InputField from "../../components/Input/Inputfeild";
import { use } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const { Option } = Select;
const {
  REACT_APP_OrgRegistryApi,
  REACT_APP_OrgjwtAud,
  REACT_APP_OrgjwtIss,
  REACT_APP_OrgjwtPrivate,
  REACT_APP_OrgjwtExp,
} = process.env;

const initialValues = {
  username: "",
  password: "",
};

const validationSchema = Yup.object({
  username: Yup.string()
    .email("Invalid email format")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Please enter a valid email address")
    .required("Please input your email!"),
  password: Yup.string().required("Please input your password!"),
});

const Login = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [success, setSuccess] = useState(false);
  const [tokenInfo, setTokenInfo] = useState({ AccessToken: "", RefreshToken: "" });
  const [permissionList, setPermissionList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [hasPasswordInput, setHasPasswordInput] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleIconClick = () => {
    setShowPassword((prev) => !prev);
  };

  const handleForgotPassword = () => {
    // Optional forgot password handler
  };

  const onChange = (value) => {
    localStorage.setItem("orgID", value.split("*")[0]);
  };

  const LoadLocations = (organizations, token) => {
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    const payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
      usertoken: token,
    };

    const privateKey = REACT_APP_OrgjwtPrivate.replace(/\\n/g, "\n");
    const jwttoken = jwt.sign(payload, privateKey, { algorithm: "RS256" });

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwttoken}`,
    };

    let Locationsarr = [];

    organizations.forEach((organization) => {
      fetch(`${REACT_APP_OrgRegistryApi}locations/${organization.OrganisationID}`, { method: "GET", headers })
        .then((res) => res.json())
        .then((ldata) => {
          Locationsarr = Locationsarr.concat(ldata.Result);
        });
    });

    setTimeout(() => {
      localStorage.setItem("children", JSON.stringify(Locationsarr));
      setIsModalVisible(true);
    }, 3000);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log("Form values:", values);
    const bdy = { UserName: values.username, Password: values.password };
    message.loading("Please wait... Validating your login", 2.5);

    const timestamp = Math.floor(Date.now() / 1000) + 1000;

    const payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
    };

    const privateKey = REACT_APP_OrgjwtPrivate.replace(/\\n/g, "\n");
    const token = jwt.sign(payload, privateKey, { algorithm: "RS256" });

    const requestOptions = {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(bdy),
    };

    try {
      const response = await fetch(`${REACT_APP_OrgRegistryApi}v1/permission/org/user/login`, requestOptions);
      const resp = await response.json();
      console.log("Login response:", resp);

      const userResponse = resp.Result;
      const permissionList = resp.Permissions;
      const accessDec = jwt.decode(userResponse.AccessToken);
      const refreshDec = jwt.decode(userResponse.RefreshToken);

      Cookies.set("infinity", userResponse.AccessToken, { expires: new Date(accessDec.exp * 1000) });
      Cookies.set("embose", userResponse.RefreshToken, { expires: new Date(refreshDec.exp * 1000) });

      localStorage.setItem("refreshToken", userResponse.RefreshToken);
      localStorage.setItem("accessToken", userResponse.AccessToken);
      localStorage.setItem("permissionList", JSON.stringify(permissionList));

      message.info("Please wait.. fetching your details.", 2.5);

      const expireTime = new Date().getTime() + REACT_APP_OrgjwtExp * 1000;
      setTokenInfo(userResponse);
      setPermissionList(permissionList);

      const userPayload = {
        aud: REACT_APP_OrgjwtAud,
        exp: expireTime,
        iss: REACT_APP_OrgjwtIss,
        usertoken: userResponse.AccessToken,
      };

      const userToken = jwt.sign(userPayload, privateKey, { algorithm: "RS256" });

      const userHeaders = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      };

      const decoded = jwt_decode(userResponse.AccessToken);
      const userRes = await fetch(`${REACT_APP_OrgRegistryApi}user/${decoded.userid}`, {
        method: "GET",
        headers: userHeaders,
      });
      const userData = await userRes.json();

      localStorage.setItem("appid", "witmegreport");
      localStorage.setItem("loggedin", true);
      localStorage.setItem("userID", userData.Result.UserID);
      localStorage.setItem("IsSpecialUser", userData.Result.IsSpecialUser);
      localStorage.setItem("fullUserDetails", JSON.stringify(userData.Result));

      const orgRes = await fetch(`${REACT_APP_OrgRegistryApi}registereduser/user/${decoded.userid}`, {
        method: "GET",
        headers: userHeaders,
      });
      const orgData = await orgRes.json();

      if (orgData.Result.length > 1) {
        message.info("Please wait.. fetching your organization details.", 2.5);
        LoadLocations(orgData.Result, userResponse.AccessToken);
      } else {
        localStorage.setItem("appID", userData.Result.UserID + "-app");
        localStorage.setItem("orgID", orgData.Result[0].OrganisationID);
        dispatch(
          signin({
            username: values.username,
            isSigned: true,
            userData: accessDec,
            accessToken: userResponse.AccessToken,
            refreshToken: userResponse.RefreshToken,
            permissions: permissionList,
          }),
        );
        setSuccess(true);
      }
    } catch (error) {
      console.error(error);
      message.error("Invalid Login!! Email Address/Password is invalid.");
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return <Redirect to="/" />;
  }
  return (
    <AuthLayout>
      <EcouiItemsChecker>
        <div className="signin-container">
          <div className="signin-header">
            <h1>Welcome Back</h1>
            <p>Please enter your credentials</p>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur={false}
            validateOnChange={true}
            validateOnMount={false}
          >
            {({ isSubmitting, errors, touched, setFieldTouched }) => (
              <FormikForm className="login-form">
                <div className="input-wrapper">
                  <p>Email Address</p>
                  <Field name="username">
                    {({ field }) => (
                      <InputField
                        {...field}
                        placeholder="Email Address"
                        className={`custom-input ${errors.username && touched.username ? "input-error" : ""}`}
                        onChange={(e) => {
                          field.onChange(e); // Call Formik's onChange
                          if (touched.username) {
                            // Clear the touched state when user starts typing
                            setFieldTouched("username", false);
                          }
                        }}
                      />
                    )}
                  </Field>
                  <ErrorMessage name="username" component="div" className="error-message" />
                </div>

                <div className="input-wrapper">
                  <p>Password</p>
                  <Field name="password">
                    {({ field }) => (
                      <InputField
                        {...field}
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        icon={hasPasswordInput ? (showPassword ? EyeOffIcon : EyeOnIcon) : null}
                        iconClick={hasPasswordInput ? handleIconClick : undefined}
                        className={`custom-input ${errors.password && touched.password ? "input-error" : ""}`}
                        onChange={(e) => {
                          field.onChange(e);
                          setHasPasswordInput(e.target.value.length > 0);
                          if (e.target.value.length === 0) {
                            setShowPassword(false);
                          }
                          if (touched.password) {
                            setFieldTouched("password", false);
                          }
                        }}
                      />
                    )}
                  </Field>
                  <ErrorMessage name="password" component="div" className="error-message" />
                </div>

                <div className="remember-me-container">
                  <div className="remember-me-wrapper">
                    <Field name="remember" type="checkbox" />
                    <label htmlFor="remember"> Remember Me </label>
                  </div>
                  <label
                    htmlFor="forget-password"
                    className="forget-password"
                    onClick={() => history.push("/forget-password")}
                  >
                    Forgot password?
                  </label>
                </div>

                <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Signing In..." : "Sign In"}
                </Button>
              </FormikForm>
            )}
          </Formik>

          <Modal
            title="Organization Location Selection"
            visible={isModalVisible}
            onOk={() => {
              setIsModalVisible(false);
              dispatch(
                signin({
                  isSigned: true,
                  accessToken: tokenInfo.AccessToken,
                  refreshToken: tokenInfo.RefreshToken,
                  permissions: permissionList,
                }),
              );
              setSuccess(true);
            }}
            onCancel={() => setIsModalVisible(false)}
          >
            <p>You're part of multiple organizations. Please select one to continue:</p>
            <Select style={{ width: 200 }} onChange={onChange} placeholder="Select a location">
              {localStorage.getItem("children") &&
                JSON.parse(localStorage.getItem("children")).map((location) => (
                  <Option key={location.OrganisationID} value={location.OrganisationID + "*" + location.Name}>
                    {location.Name}
                  </Option>
                ))}
            </Select>
          </Modal>
        </div>
      </EcouiItemsChecker>
    </AuthLayout>
  );
};

export default Login;
